import { GOLD, RADIUS } from '../../lib/medievalTheme';
import { t } from '../../localization/t';

const FRAME_STYLE = {
  position: 'absolute',
  left: '50%',
  top: '50%',
  border: `1px solid ${GOLD} 0.55)`,
  boxShadow: '0 4px 10px rgba(0,0,0,0.6)',
  background: '#0c0a08',
  overflow: 'hidden',
};

/**
 * Per-host "this card has equipment attached" indicator. Renders a small
 * stack of the attached cards' thumbnails centered on each host card so
 * players can see what is equipped without hovering. Fades out when
 * the host is hovered (HoverEquippedCards fades in with the full-size
 * side stack).
 *
 * Position and size are driven by per-frame CSS variables set by
 * GameBoard.updateEquipmentOverlaysPosition:
 *
 *   --eqstack-card-w  host's projected width (px). Drives thumb size
 *
 * The element's own `transform` is also written per frame, anchoring
 * it to the host's center. data-hovered toggles the cross-fade.
 */
export default function EquipmentStacks({ entries, registerRef }) {
  const list = entries || [];
  if (list.length === 0) return null;
  return (
    <div aria-hidden="true">
      {list.map(({ cardId, equippedCards }) => (
        <MiniStack
          key={cardId}
          cardId={cardId}
          equippedCards={equippedCards}
          registerRef={registerRef}
        />
      ))}
    </div>
  );
}

function MiniStack({ cardId, equippedCards, registerRef }) {
  const setRef = (el) => registerRef(cardId, el);
  const n = equippedCards.length;
  return (
    <div
      ref={setRef}
      data-card-id={cardId}
      className="equipment-link-badge"
      title={n > 1 ? t('{n} cards attached', { n }) : t('Card attached')}
    >
      {equippedCards.map((eq, i) => {
        // Later cards fan slightly so a stack reads as a stack.
        const offset = (i - (n - 1) / 2) * 12;
        const tilt = (i - (n - 1) / 2) * 6;
        return (
          <div
            key={eq.id}
            className={eq.isSite ? 'equipment-mini-thumb is-site' : 'equipment-mini-thumb'}
            style={{
              ...FRAME_STYLE,
              borderRadius: eq.isSite ? RADIUS.cardLandscape : RADIUS.card,
              transform: `translate(-50%, -50%) translateX(${offset}%) rotate(${tilt}deg)`,
              zIndex: i,
            }}
          >
            <img
              src={eq.imageUrl || ''}
              alt={eq.name || ''}
              style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
            />
          </div>
        );
      })}
    </div>
  );
}
